const vishingStates = [
  'campaign_name',
  'attacker_profile_call',
  'preview'
];

Object.defineProperty(vishingStates, "inbound", {
  value: [
            'campaign_name', 'template', 'ai_conversation', 'voice_selection', 'attacker_profile', 'preview'
        ],
  enumerable: false
});

/** Direct WhatsApp: Template Name → Attacker Profile → SMS template → … */
const whatsappStates = [
  'campaign_name',
  'attacker_profile_sms',
  'template_sms',
  'page',
  'awareness_page',
  'preview'
];

Object.defineProperty(whatsappStates, "inbound", {
  value: [
            'campaign_name', 'template', 'ai_conversation', 'attacker_profile', 'preview'
        ],
  enumerable: false
});

export default {
    "Simulation Attack": {
        'Phishing': [
            'campaign_name', 'template', 'page', 'awareness_page', 'attacker_profile', 'preview'
        ],
        'Smishing': [
            'campaign_name', 'template_sms', 'page', 'awareness_page', 'attacker_profile_sms', 'preview'
        ],
        'Ransomware': [
            'campaign_name', 'template', 'page', 'ransomware_file', 'attacker_profile', 'preview'
        ],
        'Vishing': vishingStates,
        'Cyber Scam': [
            'campaign_name', 'template', 'page', 'awareness_page', 'attacker_profile', 'preview'
        ],
        'WhatsApp': whatsappStates,
        'Attachment': [
            'campaign_name', 'template', 'awareness_page', 'attacker_profile', 'preview'
        ],
        'QRcode': [
            'campaign_name', 'template', 'page', 'awareness_page', 'attacker_profile', 'preview'
        ],
        'Telegram': [
            'campaign_name', 'template_telegram', 'page', 'awareness_page', 'attacker_profile_telegram', 'preview'
        ],
    },
    "Simulation Attack + Training": {
        'Phishing': [
            'campaign_name', 'template', 'page', 'awareness_page', 'attacker_profile', 'preview'
        ],
        'Smishing': [
            'campaign_name', 'template_sms', 'page', 'awareness_page', 'attacker_profile_sms', 'preview'
        ],
        'Cyber Scam': [
            'campaign_name', 'template', 'page', 'awareness_page', 'attacker_profile', 'preview'
        ],
        'Attachment': [
            'campaign_name', 'template', 'awareness_page', 'attacker_profile', 'preview'
        ],
        'QRcode': [
            'campaign_name', 'template', 'page', 'awareness_page', 'attacker_profile', 'preview'
        ],
        'Telegram': [
            'campaign_name', 'template_telegram', 'page', 'awareness_page', 'attacker_profile_telegram', 'preview'
        ],
        'WhatsApp': whatsappStates,
    },
    "Awareness Training": {
        'Training': [
            'campaign_name', 'awareness_page', 'training', 'attacker_profile', 'preview'
        ],
        'Training + Quiz': [
            'campaign_name', 'awareness_page', 'training', 'attacker_profile', 'preview'
        ],
        'Attachment': [
            'campaign_name', 'template', 'awareness_page', 'attacker_profile', 'preview'
        ]
    },
    "Gamified": {
        'Game': [
            'campaign_name', 'template', 'awareness_page', 'game', 'attacker_profile', 'preview'
        ]
    }
}
